import { Routes, Route } from "react-router-dom";
import Templates from "./Templates";
import TemplateEdit from "./TemplateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<Templates />} />
			<Route path='/:idOrName/edit' element={<TemplateEdit />} />
		</Routes>
	);
};

export default index;
